/**
 * A Promise to delay a Promise
 * @param timeout number
 * @returns Promise<void>
 */ const delay = (timeout)=>new Promise((_)=>setTimeout(_, timeout));

export { delay };
//# sourceMappingURL=delay.js.map
